import { setupAbstractContentBuilder } from './AbstractContentBuilder.js';
import { addCollapsibleList } from './collapsible-list-builder-api.js';
import { addNode, addListNode, addTextNode } from './node-builder-methods.js';
import { addTable } from './table-builder-api.js';
import 'lodash';
import 'ricos-schema';
import 'ricos-schema/dist/statics/bulleted_list.defaults.json';
import 'ricos-schema/dist/statics/ordered_list.defaults.json';
import '../converters/nodeUtils.js';
import '../ReadonlyNonEmptyArray-3599e877.js';
import '../string-04247af1.js';
import 'uuid';
import '../utils.js';
import '../converters/generateRandomId.js';
import './builder-utils.js';
import '../Option-87dfe66c.js';
import '../fp-utils-57808465.js';
import './modify.js';
import '../modifier-infra.js';
import '../index-907c0cc3.js';
import '../ReadonlyRecord-da7aaead.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const firstLetterUpperCase = (str) => `${str.charAt(0).toUpperCase()}${str.substring(1)}`;
const setupContentBuilder = (generateId) => {
  class RicosContentBuilder {
  }
  const builderApis = setupAbstractContentBuilder(
    generateId,
    addTextNode,
    addListNode,
    addNode,
    addTable,
    addCollapsibleList,
    (name) => `add${firstLetterUpperCase(name)}`
    // addParagraph, addTable, ...
  );
  return __spreadValues({
    RicosContentBuilder
  }, builderApis);
};

export { setupContentBuilder };
//# sourceMappingURL=RicosContentBuilder.js.map
